import { motion } from "framer-motion";
import { PaperBG } from "../kits";

const storyChapters = [
  {
    id: "01",
    title: "Der Anfang",
    year: "~2005",
    content: `Mit 25, mitten im Wirtschaftsinformatik-Studium, kam eine Anfrage: "Kannst du eine Software bauen, mit der Kunden interaktiv Häuser konfigurieren können – inklusive Inneneinrichtung?"`,
    highlight: `Ich sagte ja. Ahnung hatte ich keine.`,
    conclusion: `4 Monate später lief die Software. Das war der Moment, in dem ich verstand: Ich löse Probleme, indem ich entwickle.`,
  },
  {
    id: "02",
    title: "Der Umweg",
    year: "~2010",
    content: `Nach dem Studium: Klassische Unternehmensberatung für Hardware und Netzwerktechnik. Zu viel interne Strukturen, zu wenig echte Wirkung.`,
    highlight: `Ich wollte nicht optimieren – ich wollte erschaffen.`,
    conclusion: `Die Idee für meine Doktorarbeit: Server-Abwärme als Heizungsluft nutzen. Anders denken war schon immer mein Ding.`,
  },
  {
    id: "03",
    title: "Die kreative Phase",
    year: "~2012",
    content: `Dann kamen Jahre in Film und Animation. Das Polygon war immer meine Freude – 3D-Modelle, Animationen, visuelle Welten erschaffen.`,
    highlight: `Dabei entdeckte ich Python-Scripting.`,
    conclusion: `Kleine Plugins, die Workflows optimierten. Design und Code – das war keine Entscheidung, sondern eine Erkenntnis.`,
  },
  {
    id: "04",
    title: "Der Lehrende",
    year: "~2015",
    content: `An der Uni: GameDesign-Dozent für Unity und Maya. Nicht "wie geht die Software" – sondern "wie erreichst du dein Ziel".`,
    highlight: `Befähigen statt nur Abliefern.`,
    conclusion: `Diese Tätigkeit mache ich bis heute. Weil ich glaube: Wissen, das geteilt wird, wächst.`,
  },
  {
    id: "05",
    title: "Heute",
    year: "jetzt",
    content: `Zwischendurch immer wieder Projekte für Telekom, adidas, Siemens und andere – reale Herausforderungen, virtuelle Modelle, three.js, React, Flutter.`,
    highlight: `So bleibe ich: Design + Code. Dozent + Entwickler.`,
    conclusion: `Nicht entweder oder. Sondern beides. Weil echte Lösungen beides brauchen.`,
  },
];

export default function MeineGeschichte() {
  return (
    <PaperBG>
      <div id="meinweg" className="py-12 md:py-20">
        <div className="max-w-3xl mx-auto px-6">

          {/* Header */}
          <div className="mb-12">
            <span className="inline-block text-[10px] font-mono uppercase tracking-[0.3em] text-[#AC8E66] mb-2">
              Mein Weg
            </span>
            <h2 className="text-lg md:text-xl font-mono font-bold text-gray-900">
              Keine gerade Linie – jedoch ein klarer Fokus.
            </h2>
          </div>

          {/* Timeline */}
          {storyChapters.map((chapter, i) => (
            <motion.div
              key={chapter.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-80px" }}
              className="relative pl-8 md:pl-12 pb-12 last:pb-0"
            >
              {/* Timeline line */}
              {i < storyChapters.length - 1 && (
                <div className="absolute left-[11px] md:left-[19px] top-8 bottom-0 w-px bg-[#AC8E66]/20" />
              )}
              {/* Timeline dot */}
              <div className="absolute left-0 md:left-2 top-1 w-6 h-6 rounded-full bg-[#151515] border-2 border-[#AC8E66]/50 flex items-center justify-center">
                <span className="text-[8px] font-mono text-[#AC8E66] font-bold">{chapter.id}</span>
              </div>
              {/* Chapter header */}
              <div className="flex items-baseline gap-3 mb-3">
                <h3 className="text-sm md:text-base font-mono font-semibold text-gray-900">
                  {chapter.title}
                </h3>
                <span className="text-[10px] font-mono text-[#AC8E66]/60">{chapter.year}</span>
              </div>
              {/* Content */}
              <p className="text-xs md:text-sm text-gray-700 leading-relaxed mb-3 font-mono">
                {chapter.content}
              </p>
              {/* Highlight */}
              <p className="text-sm md:text-base text-[#AC8E66] font-semibold mb-3 font-mono">
                {chapter.highlight}
              </p>
              {/* Conclusion */}
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed font-mono">
                {chapter.conclusion}
              </p>
            </motion.div>
          ))}

        </div>
      </div>
    </PaperBG>
  );
}
